import { useState as a } from "react";
import { u } from "./use-isomorphic-layout-effect.BGfaCOP1.js";
const h = typeof window > "u", L = (r, {
  defaultValue: n = !1,
  initializeWithValue: o = !0,
  isActive: s = !0
} = {}) => {
  const [d, i] = a(!1), [c, m] = a(() => !o || h ? n : window.matchMedia(r).matches);
  return u(() => {
    if (!s)
      return;
    i(!0);
    const e = window.matchMedia(r), t = () => m(e.matches);
    return t(), e.addListener ? (e.addListener(t), () => e.removeListener(t)) : (e.addEventListener("change", t), () => e.removeEventListener("change", t));
  }, [r, s]), d ? c : n;
};
export {
  L as u
};
//# sourceMappingURL=use-media-query.CzJ6WnFm.js.map
